(function () {
  angular.module("akitabox.ui.dialogs.workOrderLog", [
    "akitabox.ui.dialogs.workOrderLog.createUpdate",
    "akitabox.ui.dialogs.workOrderLog.delete",
  ]);
})();
